import React, { useEffect, useState, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ThemeAction from './redux/actions/ThemeAction';
import Topnav from './components/topnav/TopNav';
import LoginPage from './pages/auth/LoginPage';
import ForgotPassword from './pages/auth/ForgotPassword';
import { ProductContext } from './ProductProvider';
import LandingPage from './pages/LandingPage';
import ChangePassword from './pages/auth/ChangePassword';
import Sidebar from './components/prosidebar/Sidebar';
import LogoutPage from './pages/auth/LogoutPage';
import './App.css';
import CourseView from './pages/student/CourseView';
import MyProfile from './pages/student/MyProfile';
import MarksMainView from './pages/marksheet/MarksMainView';
import SliderViewer from './pages/website/SliderViewer';
import GalleryViewer from './pages/website/GalleryViewer';
import ActiveInfo from './pages/website/infoDesk/ActiveInfo';

function HomePage() {
  const themeReducer = useSelector(state => state.ThemeReducer);
  const dispatch = useDispatch();
  const { loggedUser, sidebarStatus, setSidebarStatus } = useContext(ProductContext);
  const [collapsed, setCollapsed] = useState(true);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleCollapsedLeftChange = (event) => {
    if (event) event.preventDefault();
    setCollapsed(true);
    setSidebarStatus("Shrunk");
  };

  const handleCollapsedRightChange = (event) => {
    if (event) event.preventDefault();
    setCollapsed(false);
    setSidebarStatus("Orginal");
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  useEffect(() => {
    const themeClass = localStorage.getItem('themeMode') || 'theme-mode-light';
    const colorClass = localStorage.getItem('colorMode') || 'theme-color-blue';
    dispatch(ThemeAction.setMode(themeClass));
    dispatch(ThemeAction.setColor(colorClass));
  }, [dispatch, loggedUser, sidebarStatus]);

  const mainContentClass = !loggedUser.isAuthenticated
    ? "layout__content-full"
    : sidebarStatus === "Full"
      ? "layout__content-full"
      : sidebarStatus === "Orginal"
        ? "layout__content-main"
        : "layout__content";

  return (
    <div className={`layout ${themeReducer.mode} ${themeReducer.color}`}>
      <div className="app">
        {loggedUser.isAuthenticated && (
          <Sidebar
            collapsed={collapsed}
            toggled={toggled}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapsedChange={handleCollapsedChange}
            handleCollapsedLeftChange={handleCollapsedLeftChange}
            handleCollapsedRightChange={handleCollapsedRightChange}
          />
        )}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, width: '100%' }}>
          {loggedUser.isAuthenticated && (
            <Topnav toggleMobileSidebar={() => setToggled(!toggled)} />
          )}
          <main className={mainContentClass}>
            <div className={loggedUser.isAuthenticated ? "page-container" : "auth-container"}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/marksheet" element={<MarksMainView />} />
                <Route path="/course" element={<CourseView />} />
                <Route path="/profile" element={<MyProfile />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                {/*} <Route path="/slider-viewer" element={<SliderViewer />} />
                <Route path="/gallery-viewer" element={<GalleryViewer />} />
                <Route path="/infodesk" element={<ActiveInfo />} />*/}
              </Routes>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
